import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { TeamsService } from 'src/app/services/teams.service';

@Component({
  selector: 'app-editor-request',
  templateUrl: '../request/request.component.html',
  styleUrls: ['../request/request.component.scss'],
  standalone: false,
})
export class EditorRequestComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  success = false;
  fail = false;
  loadingMessage = 'Accepting invitation...';

  constructor(
    private route: ActivatedRoute,
    private teamsService: TeamsService,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const requestId = params.get('reqId');
      if (!requestId) {
        this.fail = true;
        return;
      }

      this.route.queryParamMap.pipe(take(1)).subscribe((qParams) => {
        const action = qParams.get('accept') ? 'accept' : qParams.get('decline') ? 'decline' : null;

        if (action === 'accept') {
          this.teamsService.acceptEditorInvite(requestId).pipe(take(1)).subscribe({
            next: () => (this.success = true),
            error: (err) => {
              console.error('Failed to accept editor invitation: ', err);
              this.fail = true;
            },
          });
        } else if (action === 'decline') {
          this.loadingMessage = 'Declining invitation...';
          this.teamsService.declineEditorInvite(requestId).pipe(take(1)).subscribe({
            next: () => (this.success = true),
            error: (err) => {
              console.error('Failed to decline editor invitation: ', err);
              this.fail = true;
            },
          });
        } else {
          this.fail = true;
        }
      });
    });
  }
}
